import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import InlineTable, { InlineColDef } from '../util/InlineTable';

interface Dept { id: number; title: string; active?: boolean; }

const columns: InlineColDef<Dept>[] = [
  { key: 'title', label: t('Name') || 'Name', type: 'text' },
];

const Department: React.FC = () => {
  const [rows, setRows] = useState<Dept[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await axios.get('department'); setRows(Array.isArray(data) ? data : []); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <InlineTable<Dept>
      columns={columns}
      rows={rows}
      getKey={r => r.id}
      loading={loading}
      addLabel={`+ ${t('Create') || 'Add'} ${t('DepT') || 'Department'}`}
      defaultValues={{ title: '' }}
      onAdd={async row => { await axios.post('department/add', row); load(); }}
      onEdit={async (id, row) => { await axios.put(`department/${id}`, row); load(); }}
      onDelete={async id => { await axios.delete(`department/${id}`); load(); }}
      emptyText={t('Empty') || 'No departments'}
    />
  );
};

export default Department;
